export type Type = {
	id: string;
	label: string;
	maximum: number | null;
	minimum: number | null;
};

export function create(): Type {
	return {
		id: '',
		label: '',
		maximum: null,
		minimum: null,
	};
}
